import React, { useContext, useCallback } from 'react';
import { filterContext, FilterItemProps } from '../FilterProvider';
import { Pagination, PaginationProps } from '../Pagination';

export type PaginationFilterProps = PaginationProps & FilterItemProps;

export function PaginationFilter({
  onPageChange = () => {
    // empty
  },
  name,
  ...rest
}: PaginationFilterProps) {
  const context = useContext(filterContext);

  const innerOnChange = useCallback(
    (page: number) => {
      onPageChange(page);
      context.onFilterItemChange(name, page);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onPageChange, name]
  );

  return <Pagination {...rest} onPageChange={innerOnChange} />;
}
